import React from "react";
import PopupWin from "../../../../../components/PopupWin";

const DeleteMappingModal = ({ visible, onClose, onConfirm, profileName }) => {
  return (
    <PopupWin
      visible={visible}
      onClose={onClose}
      hideClose={false}
      popupStyle={{
        width: "427px",
        minHeight: "200px",
        padding: 0,
        background: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0px 9px 25px 0px rgba(129, 155, 163, 0.27)",
      }}
      contentStyle={{
        padding: "40px 60px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <h2 className="delete-mapping-modal-title">Delete Mapping Profile?</h2>
      <p className="delete-mapping-modal-description">
        Are you sure you want to delete "{profileName}"? This action cannot be undone.
      </p>
      <div className="delete-mapping-modal-buttons">
        <button className="delete-mapping-modal-cancel" onClick={onClose}>
          Cancel
        </button>
        <button className="delete-mapping-modal-confirm" onClick={onConfirm}>
          Delete
        </button>
      </div>
    </PopupWin>
  );
};

export default DeleteMappingModal;
